import { Sms, User, Eye, EyeSlash, Key } from "iconsax-react";
import { Link, useNavigate } from "react-router-dom";
import instance from "../../../axios/instance";
import { saveToken } from "../../../utils/token";
import { useEffect, useState } from "react";
import { EyeOff } from "lucide-react";

export default function HWLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [success, setSuccess] = useState(false);

  const btnDisabled = !email || !password;

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");
    try {
      const res = await instance.post("/doctor/auth/login", {
        email,
        password,
        type: "clinic"
      });
      saveToken(res.data.ACCESS_TOKEN);
      navigate("/dashboard/orders");
      // setSuccess(true);
      // setLoading(false);
    } catch (error) {
      setErrorMessage(error.response.data.message);
      setLoading(false);
    }
  };

  // // test effect
  // const [logo, setLogo] = useState(null)


  // useEffect(() => {
  //   const testLogo = window.localStorage.getItem("PHARM_LOGO")
  //   if (!testLogo) {
  //     console.log("There is no logo use default");
  //     setLogo("/images/Logo.png")
  //   } else {
  //     console.log("there is logo");
  //     setLogo("/images/Logo.png")
  //   }
  // }, [])

  return (
    <main className="z-10 flex min-h-dvh flex-col justify-between">

      <div className="max-tablet:h-[50rem] relative z-10 flex h-[50rem] items-center justify-center py-24">
        {success ? (
          <div className="text-gray-600 text-center">
            <div className="text-lg font-medium mb-2">Check your email</div>
            <div className="text-sm">A link has been sent to your email address. Click on it to sign in.</div>
          </div>
        ) :

          <>
            {/* old content start */}
            <div className="max-tablet:mx-6 flex w-full max-w-[36.25rem] flex-col rounded-[30px] bg-white p-10">
              <img src="/clinic/images/hw-logo.png" alt="logo" className="size-12 self-center" />

              <h1 className="pt-6 pb-2 text-center text-[2rem]/[2.5rem] font-semibold tracking-[-0.04rem] text-black">
                Welcome Back!
              </h1>
              <p className="text-center text-base text-[#7A7D87]">
                Your path to better health and stronger wealth starts here.
              </p>

              {/* <div className="flex-1 bg-white flex flex-col justify-center px-8 lg:px-16 xl:px-24">
                <div className="max-w-md mx-auto w-full"> */}
              {/* Logo */}


              {/* Main Content */}
              {success ? (
                <div className="text-gray-600 text-center">
                  <div className="text-lg font-medium mb-2">Check your email</div>
                  <div className="text-sm">A link has been sent to your email address. Click on it to sign in.</div>
                </div>
              ) : (
                <>



                  {/* Login Form */}
                  <form onSubmit={handleLogin} className="mt-10 space-y-6">
                    {/* Email Field */}
                    <div>
                      <label htmlFor="email" className="sr-only text-sm font-medium text-black">
                        Email
                      </label>

                      <div className="relative">
                        <div className="flex items-center">
                          <div className="flex h-12 w-12 items-center justify-center rounded-l-lg border border-r-0 border-gray-300 bg-gray-50">
                            <Sms size={16} className="text-gray-400" />
                          </div>
                          <div className="h-6 w-px bg-gray-300" />
                          <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="Enter your email"
                            className="flex-1 rounded-r-lg border border-l-0 border-gray-300 bg-white px-4 py-3 text-sm placeholder-gray-500 focus:border-[#3384F5] focus:ring-1 focus:ring-[#3384F5] focus:outline-none"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Password Field */}
                    <div>
                      <label htmlFor="email" className="sr-only text-sm font-medium text-black">
                        Password
                      </label>

                      <div className="relative">
                        <div className="flex items-center">
                          <div className="flex h-12 w-12 items-center justify-center rounded-l-lg border border-r-0 border-gray-300 bg-gray-50">
                            <Key size={16} className="text-gray-400" />
                          </div>
                          <div className="h-6 w-px bg-gray-300" />
                          <input
                            id="password"
                            type={showPassword ? "text" : "password"}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="Enter your password"
                            className="flex-1 rounded-r-lg border border-l-0 border-gray-300 bg-white px-4 py-3 text-sm placeholder-gray-500 focus:border-[#3384F5] focus:ring-1 focus:ring-[#3384F5] focus:outline-none"
                          />
                          <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            className="absolute top-1/2 right-3 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                          >
                            {showPassword ? (
                              <EyeSlash className="h-5 w-5" />
                            ) : (
                              <Eye className="h-5 w-5" />
                            )}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-start">
                      <Link
                        to="/auth/forgot-password"
                        className="text-sm text-[#3384F5] hover:underline"
                      >
                        Forgot password?
                      </Link>
                    </div>

                    {/* Error Message */}
                    {errorMessage && (
                      <div className="text-red-500 text-sm font-medium">
                        {errorMessage}
                      </div>
                    )}

                    {/* Login Button */}
                    <button
                      type="submit"
                      disabled={btnDisabled || loading}
                      className="w-full rounded-2xl bg-[#3384F5] py-3 text-sm font-semibold text-white hover:bg-[#3384F5]/90"
                    >
                      {loading ? "Signing in..." : "Sign In"}
                    </button>
                  </form>

                  {/* <div className="relative mt-6 mb-10">
                    <div className="absolute inset-0 flex items-center">
                      <div className="w-full border-t border-gray-300" />
                    </div>
                    <div className="relative flex justify-center text-sm">
                      <span className="bg-white px-2 text-gray-500">or</span>
                    </div>
                  </div> */}

                  {/* <Link
                    href="https://api.id.me/en/registration/new"
                    target="_blank"
                    className="flex w-full items-center justify-center gap-2 rounded-2xl border border-[#E8E9EB] py-4 text-black hover:bg-gray-50"
                  >
                    <span>Sign in with</span>
                    <img src="/clinic/images/id.me.svg" alt="idme" />
                  </Link>

                  <p className="mt-6 text-center text-sm text-gray-600">
                    Don&apos;t have an account?{" "}
                    <Link
                      //to="https://api.id.me/en/registration/new"
                      target="_blank"
                      className="text-[#3384F5] hover:underline"
                    >
                      Sign up
                    </Link>
                  </p> */}



                </>
              )}


              {/* </div>
              </div> */}


              {/* Powered by */}
              {/* <div className="absolute bottom-4 left-4 flex items-center gap-2 text-[#111111] text-xs">
            <span>Powered by</span>
            <img src="/clinic/images/logo-bw.png" className="w-24 h-auto" alt="BCRX" />
          </div> */}
            </div>
            {/* old content end */}
          </>
        }

        <img
          src="/clinic/images/auth-bg.png"
          alt="Auth Background"
          className="absolute inset-0 -z-10 h-full w-full object-cover"
        />
      </div>

      <div className="max-tablet:px-6 max-tablet:py-8 relative z-10 bg-[#F5F9FE] px-[5.6rem] py-12 text-sm tracking-[-0.0175rem] text-[#181d26]">
        <p>
          This website is the property of Healthwealth Pharmacy Doctors and
          Distributors. It is to be used only for approved access to
          services. By continuing this online access you are certifying that
          you have read and agree to abide by the regulations listed below.
          You will be held accountable for any activities not in compliance
          with those regulations. Misuse or unauthorized access may result
          in legal prosecution or penalties under law. Penalties may include
          fines, imprisonment, termination of affiliation with Healhwealth
          Pharmacy. LOGOFF immediately if you do not agree to the conditions
          in this warning.
        </p>
      </div>

    </main>
  );
}
